import './apexam.scss';
import * as React from 'react';
import Table from '../../../../components/Table/APCP/apcptable';
import Util from '../../../../utils/APCPUtil';

// eslint-disable-next-line react/prop-types
  const ApExam = (props) => {
    const[questionTemplate, setQuestionTemplate] = React.useState();
  return (
    <div style={{width:'94%'}}>
      <div className="apexamDiv">
        <span style={{width: "100%"}} role='heading' aria-level='3' id='apcptabletitle'></span>
        <div className="btnDiv">
          <button style={{width: "200px"}} id="btn_newPolicyBtn" type="button" 
          className="cb-btn cb-btn-primary"
          disabled={!props.enableNewPolicy||props.readOnly}
          onClick={
            ()=>{
              setQuestionTemplate(()=>Util.createNewPolicy(props.moduleIdMap, props.defaultQuestions));
              props.setEnableEdit(false);
              props.setEnableRenderBtn(false);
            }
          }
          >+ Add New Policy</button>
        </div>
      </div>
      <hr className='horizontalLine' />

      <Table  moduleData={props.moduleData}
              setModuleData={props.setModuleData}
              answers={props.answers} 
              setAnswers={props.setAnswers}
              appliedModuleIds = {props.appliedModuleIds}
              setAppliedModuleIds = {props.setAppliedModuleIds}
              moduleErrors={props.moduleErrors}
              setModuleErrors={props.setModuleErrors}
              questionTemplate={questionTemplate}
              setQuestionTemplate={setQuestionTemplate}
              moduleIdMap={props.moduleIdMap}
              setPageDirty={props.setPageDirty}
              readOnly={props.readOnly}
              enableEdit={props.enableEdit}
              setEnableEdit={props.setEnableEdit}
              enableNewPolicy={props.enableNewPolicy}
              setEnableNewPolicy={props.setEnableNewPolicy}
              enableRenderBtn={props.enableRenderBtn}
              setEnableRenderBtn={props.setEnableRenderBtn}
      />
    </div>
  );
};

export default ApExam;